<!--
 There are a number of places in EE where we want to select a list of stores to do something.
 This component facilitates that.
  -->
<script lang="ts">
	import Button from '@isoftdata/svelte-button'
	import Modal from '@isoftdata/svelte-modal'

	import session from 'stores/session'
	import { getEventChecked } from '@isoftdata/browser-event'

	interface Props {
		show?: boolean
		selectedStoreIds?: Array<number>
		excludedStoreIds?: Array<number>
		title?: string
		subtitle?: string
		confirm?: (selectedStoreIds: Array<number>) => void
	}

	let {
		show = $bindable(false),
		selectedStoreIds = $bindable([]),
		excludedStoreIds = [],
		title = 'Select Stores',
		subtitle = '',
		confirm,
	}: Props = $props()

	export function hasValidStores() {
		return validStores.length > 0
	}

	export function open() {
		selectedStoreIds = []
		show = true
	}

	let excludedStoreSet = $derived(new Set(excludedStoreIds))
	let validStores = $derived($session.authorizedStores.filter(store => !excludedStoreSet.has(store.id)))
</script>

<Modal
	{title}
	{subtitle}
	bind:show
	close={() => (show = false)}
	confirm={() => {
		confirm?.($state.snapshot(selectedStoreIds))
		show = false
	}}
>
	{#snippet footer()}
		<Button
			iconClass="check-double"
			onclick={() => {
				if (selectedStoreIds.length === validStores.length) {
					selectedStoreIds = []
				} else {
					selectedStoreIds = validStores.map(s => s.id)
				}
			}}>Select {selectedStoreIds.length === validStores.length ? 'None' : 'All'}</Button
		>
	{/snippet}
	<ul class="list-group list-group-flush">
		{#each validStores as store (store.id)}
			<li class="list-group-item">
				<input
					id="store-{store.code}"
					type="checkbox"
					class="me-3"
					checked={selectedStoreIds.includes(store.id)}
					onchange={event => {
						if (getEventChecked(event)) {
							selectedStoreIds.push(store.id)
							selectedStoreIds = selectedStoreIds
						} else {
							selectedStoreIds = selectedStoreIds.filter(id => id !== store.id)
						}
					}}
				/><label
					class="mb-0"
					for="store-{store.code}">{store.code} - {store.name}</label
				>
			</li>
		{:else}
			<li class="list-group-item">No Stores</li>
		{/each}
	</ul>
</Modal>
